<!-- 由 suu 创建于 2022-09-02 星期五 -->
<template>
  <div class="sum-poster" :class="{ 'sum-poster-diet': !line }" ref="box">
    <!-- 海报图 -->
    <div class="mask-container" v-if="showMask" @click="tap"></div>
    <div v-if="showPoster" class="poster-img animated zoomIn" @click="tap">
      <img :src="imgUrl" alt />
    </div>
    <div class="cp-cnet" :class="{ 'cp-cnet-filter': showMask }">
      <img class="cp-bg" :src="bgImg" alt="" />
      <!-- 鸡汤 -->
      <div class="cp-text">{{
        jsTxet || '你坚持的东西，总有一天会反过来拥抱你。'
      }}</div>
      <!-- 天数 打卡 -->
      <!-- <div class="cp-days">在betterWE的第{{ info.userResult.day_num }}天</div> -->
      <div class="cp-card">
        本周打卡(次)
        <span>{{ info.comprehensiveData.clockList.dietNum }}</span>
      </div>
      <!-- 勋章 -->
      <img
        class="cp-medal"
        :src="info.comprehensiveData.achievementName.medal_url"
        alt=""
      />
      <!-- 用户信息 -->
      <div class="cp-user" v-if="info.userResult">
        <img
          class="u-img"
          :src="
            info.userResult.head_img ||
            'https://cdnvue.gymcity.com.cn/uploads/474b47b400369d72944da3aa665924b3.png'
          "
          alt=""
        />
        <div class="u-right">
          <div class="u-name">{{
            info.userResult.truename || info.userResult.nickname
          }}</div>
          <div class="u-desc">{{ info.userResult.alias }}</div>
        </div>
      </div>
      <!-- 变量 体重 -->
      <div class="cp-change">
        <template v-if="line">
          <div class="c-item">
            <div class="i-title">体重变化(斤)</div>
            <div class="i-num">{{
              info.comprehensiveData.fatReduction.weight_diff * 2
            }}</div>
          </div>
          <div class="c-item">
            <div class="i-title">腰围变化(厘米)</div>
            <div class="i-num">{{
              info.comprehensiveData.fatReduction.waist_diff
            }}</div>
          </div>
          <div class="c-item">
            <div class="i-title">约等于减掉了</div>
            <div class="i-imgs">
              <!-- 水果 -->
              <!-- <template
                v-if="info.comprehensiveData.fruitContent.fruit_num <= 3"
              >
                <img
                  class="img-sg"
                  v-for="(item, index) in curSgNum"
                  :key="index"
                  :src="curSg"
                  alt=""
                /> -->
              <!-- 半个水果 -->
              <!-- <img
                  class="img-sg img-sg-b"
                  v-if="showSgImgB"
                  :src="curSgB"
                  alt=""
                />
              </template> -->
              <!-- <template v-else> -->
              <template>
                <img class="img-sg img-sg-text" :src="curSg" alt="" />
                <span class="img-text">
                  <span>X</span>
                  {{ info.comprehensiveData.fruitContent.fruit_num }}
                </span>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="c-item">
            <div class="i-title">打卡次数</div>
            <div class="i-num">{{
              info.comprehensiveData.clockList.dietNum
            }}</div>
          </div>
          <div class="c-item">
            <div class="i-title">打卡天数</div>
            <div class="i-num">{{ info.comprehensiveData.actualDay }}</div>
          </div>
        </template>
      </div>
      <div class="cp-change-dev">
        {{
          line
            ? info.comprehensiveData.fruitContent.content
            : info.comprehensiveData.fruitContent.common_content
        }}
      </div>
      <!-- 二维码 -->
      <div class="qr-region">
        <canvas class="qr" id="qrCode-canvas"></canvas>
      </div>
    </div>
    <ShareBar
      v-if="showPoster && isApp"
      :shareType="1"
      class="share-bar"
      @image="handleShare"
    ></ShareBar>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
import ShareBar from '@/views/useBoth/ingredient-list/components/share.vue'
export default {
  name: 'sum-poster',

  components: { ShareBar },

  props: {
    info: {}
  },

  data() {
    return {
      jsTxet: '',
      imgUrl: '',
      showMask: false,
      showPoster: false,
      isApp: false
    }
  },

  computed: {
    // 当前水果
    curSg() {
      return this.info.comprehensiveData.fruitContent.icon
    },
    curSgB() {
      return this.info.comprehensiveData.fruitContent.half_icon
    },
    showSgImgB() {
      const num = this.info.comprehensiveData.fruitContent.fruit_num
      const num_1 = String(num).split('.')[1]
      if (num < 3 && num_1 && num_1 !== '0') {
        return true
      }
      return false
    },
    curSgNum() {
      const num = this.info.comprehensiveData.fruitContent.fruit_num
      if (num <= 3) {
        return Number(num.split('.')[0])
      }
      return num
    },
    // 体重 腰围都又减少 显示曲线版本
    line() {
      return (
        this.info.comprehensiveData.fatReduction.weight_diff < 0 &&
        this.info.comprehensiveData.fatReduction.waist_diff < 0
      )
    },
    // 背景图
    bgImg() {
      return this.line
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-hb-bg-qx'
        : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-hb-bg'
    },
    // 分享二维码链接
    qrcodeUrl() {
      return 'https://member3.gymcity.com.cn/#/app-download?sfrom=weekSummary'
    }
  },

  watch: {},

  created() {
    this.jsTxet =
      this.info.dietReview.shareContent[
        this.RandomNumBoth(0, this.info.dietReview.shareContent.length - 1)
      ]
    if (this.$http._isApp()) this.isApp = true
  },

  mounted() {
    setTimeout(() => {
      this.getImg()
    }, 200)
  },

  destroyed() {},

  methods: {
    // 点击分享
    handleShare(i) {
      console.log('iii', i)
      switch (i) {
        case 0:
          this.handelSaveImg()
          break
        case 1:
          this.handelShare(1)
          break
        case 2:
          this.handelShare(2)
          break

        default:
          break
      }
    },
    // 分享微信
    handelShare(shareType) {
      this.$betterwe.onAppShare({
        shareType: shareType, //分享的类型 1 微信好友 2 微信朋友圈
        contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
        // 分享的数据
        shareData: {
          data: this.imgUrl, //分享的具体数据
          //分享的数据的格 式
          //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
          type: 'base64',
          desc: '快来打call领奖吧~',
          title: '为喜爱的营养师打call，领取100元优惠礼包！'
        }
      })
    },
    // 保存到手机
    handelSaveImg() {
      this.$betterwe.onAppSaveImage({
        data: this.imgUrl, //分享的具体数据
        //分享的数据的格式
        //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'base64'
      })
    },
    /**
     * 生成随机数
     */
    RandomNumBoth(Min, Max) {
      var Range = Max - Min
      var Rand = Math.random()
      var num = Min + Math.round(Rand * Range) // 四舍五入
      return num
    },
    // 点击已生成图片
    tap() {
      if (this.showMask) {
        this.$emit('close')
      }
    },
    /**
     * 生成海报
     */
    getImg() {
      const that = this
      console.log('that.$refs.box', this.qrcodeUrl)
      window.scrollTo(0, 0)
      this.$toast.loading('生成海报中...')
      setTimeout(() => {
        this.$nextTick(() => {
          // 合成分享图
          let canvas = document.getElementById('qrCode-canvas')
          QRCode.toCanvas(canvas, that.qrcodeUrl, (error) => {
            if (error) {
              console.log(error)
            } else {
              html2canvas(that.$refs.box, {
                backgroundColor: null,
                useCORS: true
              })
                .then(function (canvas) {
                  that.$toast.clear()
                  that.imgUrl = canvas.toDataURL()
                  that.$emit('over', that.imgUrl)
                  window.scrollTo(0, 0)
                  that.$toast.clear()
                  that.showMask = true
                  setTimeout(() => {
                    that.showPoster = true
                    that.$toast('图片已生成，快分享给你的好友吧')
                  }, 100)
                })
                .catch((err) => {})
            }
          })
        })
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.sum-poster {
  width: 315px;
  height: 523px;
  // background-color: #fff;
  position: absolute;
  top: 10000px;
  // top: 0px;
  // left: 0;
  // transform: translateX(-50%);
  z-index: 88;
  display: flex;
  flex-direction: column;
  align-items: center;
  .mask-container {
    background-color: #000;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.6;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .poster-img {
    width: 80%;
    position: fixed;
    top: 1%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -68%);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .cp-cnet {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 100;
    .cp-bg {
      width: 100%;
      box-sizing: border-box;
    }
    .cp-text {
      width: 144px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 28px;
      position: absolute;
      top: 22px;
      left: 20px;
    }
    .cp-days {
      font-size: 10px;
      font-weight: 400;
      position: absolute;
      top: 25px;
      right: 16px;
      color: rgba($color: #000000, $alpha: 0.7);
    }
    .cp-card {
      padding: 4px 6px;
      border-radius: 4px;
      border: 1px solid rgba($color: #000000, $alpha: 0.1);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: rgba($color: #000000, $alpha: 0.7);
      font-size: 10px;
      position: absolute;
      right: 16px;
      top: 47px;
      background: linear-gradient(175deg, #edfbff 0%, #bdf5fe 100%);
      box-shadow: inset 0px 2px 1px 0px rgba(255, 255, 255, 0.79),
        inset 0px -1px 3px 0px rgba(126, 229, 253, 1);
      border-radius: 4px;
      border: 1px solid #7ee5fd;
      span {
        font-size: 20px;
        font-weight: 600;
      }
    }
    .cp-medal {
      width: 117px;
      position: absolute;
      right: 10px;
      top: 111px;
    }
    .cp-user {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 20px;
      top: 228px;
      .u-img {
        width: 40px;
        height: 40px;
        border: 2px solid #ffffff;
        box-sizing: border-box;
        border-radius: 50%;
      }
      .u-right {
        margin-left: 8px;
        .u-name {
          font-size: 13px;
          font-weight: 500;
        }
        .u-desc {
          font-size: 10px;
          font-weight: 400;
          color: rgba($color: #000000, $alpha: 0.5);
          margin-top: 2px;
        }
      }
    }
    .cp-change {
      width: 274px;
      padding-top: 16px;
      border-top: 1px solid #d8d8d8;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      top: 278px;
      left: 20px;
      .c-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .i-title {
          font-size: 10px;
          font-weight: 500;
          color: rgba($color: #000000, $alpha: 0.7);
        }
        .i-num {
          font-size: 30px;
          font-family: 'DINC';
          font-weight: bold;
          color: rgba($color: #000000, $alpha: 0.8);
          margin-top: 6px;
        }
        .i-imgs {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 4px;
          img {
            width: 35px;
            & + img {
              margin-left: 2px;
            }
          }
          .img-sg-text {
            position: relative;
            top: -3px;
          }
          .img-text {
            font-size: 28px;
            font-family: 'DINC';
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            bottom: -1px;
            span {
              opacity: 0.4;
              font-size: 16px;
              margin: 0 4px;
            }
          }
        }
      }
    }
    .cp-change-dev {
      width: 275px;
      padding: 5px 12px;
      box-sizing: border-box;
      background: rgba($color: #fff, $alpha: 0.6);
      color: #666;
      margin-top: 4px;
      font-size: 10px;
      font-weight: 400;
      border-radius: 8px;
      position: absolute;
      top: 358px;
      // bottom: 96px;
      letter-spacing: 0px;
      &::after {
        content: '';
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid rgba($color: #fff, $alpha: 0.6);
        border-right: 6px solid transparent;
        border-left: 6px solid transparent;
        position: absolute;
        top: 0;
        transform: translateY(-100%);
        right: 50px;
      }
    }
    .qr-region {
      position: absolute;
      bottom: 7px;
      right: 18px;
      text-align: center;
      #qrCode-canvas {
        width: 68px !important;
        height: 68px !important;
      }
    }
  }
  .share-bar {
    width: 100vw;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 101;
  }
}
// 非曲线
.sum-poster-diet {
  .cp-cnet .cp-text {
    top: 48px;
    line-height: 31px;
  }
  .cp-cnet .cp-user {
    top: 198px;
  }
  .cp-cnet .cp-change {
    top: 248px;
    justify-content: space-around;
  }
  .cp-cnet .cp-change-dev {
    font-size: 13px;
    top: 323px;
  }
}
</style>
